import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth-provider.js';
import { appPaths } from '@/app/router/paths.js';
import { canEnterOrganizationSettings } from '@/features/organization-settings/organization-settings-access.js';

export function RequireOrganizationSettings({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();

  if (status === 'loading') {
    return null;
  }

  if (status !== 'authenticated' || !user) {
    return <Navigate to={appPaths.login} replace />;
  }

  if (!canEnterOrganizationSettings(user.roles)) {
    return <Navigate to={appPaths.home} replace />;
  }

  return children;
}
